/* eslint-disable @typescript-eslint/naming-convention */

import API_BASE_URL from 'src/constants';

export interface DownloadConfig {
  url: string;
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
  headers?: Record<string, string>;
  body?: any;
  filename?: string;
  queryParams?: Record<string, string | undefined>;
}

export const downloadFile = async (config: DownloadConfig): Promise<Blob> => {
  const accessToken = localStorage.getItem('access_token');

  if (!accessToken) {
    throw new Error('Unauthorized');
  }

  const url = new URL(config.url);
  if (config.queryParams) {
    Object.entries(config.queryParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        url.searchParams.append(key, value);
      }
    });
  }

  const response = await fetch(url.toString(), {
    method: config.method || 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
      ...config.headers,
    },
    body: config.body ? JSON.stringify(config.body) : undefined,
  });

  if (!response.ok) {
    throw new Error(`Download failed with status ${response.status}`);
  }

  return response.blob();
};

export const triggerBlobDownload = (blob: Blob, filename: string) => {
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(downloadUrl);
};

export const triggerDownload = async (config: DownloadConfig): Promise<void> => {
  const blob = await downloadFile(config);
  const filename = config.filename || 'download.zip';
  triggerBlobDownload(blob, filename);
};

export const createBulkAttachmentsDownload = (model: string, ids: number[]) => ({
  url: `${API_BASE_URL}portal/utility/bulk_action/${model}/get_attachments_as_zip`,
  method: 'POST' as const,
  body: ids,
  filename: 'attachments.zip',
});

export const createReportDownload = (
  reportType: string,
  params: { start_date?: string; end_date?: string; [key: string]: any },
) => {
  const { start_date, end_date, ...bodyData } = params;

  return {
    url: `${API_BASE_URL}portal/advanced_reports/report/${reportType}/`,
    method: 'POST' as const,
    queryParams: { start_date, end_date },
    body: Object.keys(bodyData).length > 0 ? bodyData : undefined,
    filename: `${reportType}_report.xlsx`,
  };
};
